namespace RioERP.Web.Enums {
    export enum EnquiryStatus {
        newenquiry = 1,
        followUpRequired = 2,
        closed = 3,
        notinterested = 4,
        notResponding = 5,
        callBack = 6
    }
    Serenity.Decorators.registerEnumType(EnquiryStatus, 'RioERP.Web.Enums.EnquiryStatus');
}
